import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The group for a directional or spot light and its `target` Object3D. Godot
 * lights face -Z, so the target sits one unit along local -Z.
 */
import { useEffect, useRef } from 'react';
import * as THREE from 'three';
import { NodeAabb } from '../../../../r3f/components/NodeAabb';
import { node3dGroupSpread } from '../../../../r3f/nodeTransform';
export function LightWithTarget({ name, transform, aabb, renderLight, children }) {
    const targetRef = useRef(new THREE.Object3D());
    // A ref, not state, keeps the target's identity stable across renders.
    useEffect(() => {
        targetRef.current.name = `${name}_target`;
    }, [name]);
    return (_jsxs("group", { name: name, ...node3dGroupSpread(transform), children: [_jsx(NodeAabb, { aabb: aabb }), renderLight(targetRef.current), _jsx("primitive", { object: targetRef.current, position: [0, 0, -1] }), children] }));
}
//# sourceMappingURL=lightShared.js.map